import { render, staticRenderFns } from "./vipManage.vue?vue&type=template&id=6d2e57d6&scoped=true"
import script from "./vipManage.vue?vue&type=script&lang=js"
export * from "./vipManage.vue?vue&type=script&lang=js"
import style0 from "./vipManage.vue?vue&type=style&index=0&id=6d2e57d6&prod&lang=scss"
import style1 from "./vipManage.vue?vue&type=style&index=1&id=6d2e57d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e57d6",
  null
  
)

export default component.exports